import { styled, TextField } from "@mui/material";

const CustomizedTextField = styled(TextField)(
	({ customWidth, customHeight, customNotchHeight, customBgColor, select }) => ({
		"& .MuiInputBase-input.MuiOutlinedInput-input.MuiInputBase-inputSizeSmall": {
			padding: "0px !important"
		},
		"& .MuiList-root MuiList-padding MuiMenu-list": {
			background: "black"
		},
		"& .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #707070",
			width: customWidth || 320, // Use width prop or default to 320
			height: customNotchHeight || 42,
			paddingTop: 0.5,
			borderRadius: 5,
			opacity: 1
		},
		"& .MuiInputBase-input MuiOutlinedInput-input MuiInputBase-inputAdornedStart": {
			marginTop: "5px !important"
		},
		"& .MuiOutlinedInput-root": {
			"&:hover fieldset": {
				borderColor: "#4DB5F4"
			},
			"&.Mui-focused fieldset": {
				borderColor: "#4DB5F4"
			},

			width: customWidth || 320, // Use width prop or default to 320
			height: customHeight || 36,
			textAlign: "left",
			fontWeight: "normal",
			fontFamily: "Roboto",
			letterSpacing: "0px",
			opacity: 1,
			fontSize: 10,
			...(!select && { lineHeight: 13 }),
			color: "#B5B9BE",
			background: customBgColor || "transparent"
		}
	})
);

export default CustomizedTextField;
